import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './FeatureCard.css';

/**
 * Card for one of the things Revetall does, linking to its own page.
 * Used in the "Mer vi kan hjelpe deg med" list on feature pages.
 * @param {Object} props
 * @param {{id: string, path: string, Illustration: Function}} props.feature - Entry from FEATURES
 * @returns {JSX.Element} Feature card
 */
function FeatureCard({ feature }) {
  const { t } = useTranslation();
  const title = t(`features.${feature.id}.title`);
  const { Illustration } = feature;

  return (
    <article className="feature-card">
      <div className="feature-card-art">
        <Illustration />
      </div>
      <h3 className="feature-card-title">{title}</h3>
      <p className="feature-card-text">{t(`features.${feature.id}.intro`)}</p>
      <Link
        to={feature.path}
        className="button button-outline feature-card-button"
        aria-label={t('whatWeDo.seeHowLabel', { title })}
      >
        {t('whatWeDo.seeHow')} <span aria-hidden="true">→</span>
      </Link>
    </article>
  );
}

export default FeatureCard;
